import { Computer, PhoneAndroid } from '@material-ui/icons';
import clsx from 'clsx';
import React, { useState } from 'react';

export function DeviceSelector({ children }: { children: React.ReactNode }) {
  const [device, setDevice] = useState<'desktop' | 'mobile'>('desktop');

  return (
    <div className='relative flex min-h-screen flex-col bg-gray-200'>
      <div className='flex h-[52px] items-center justify-center bg-gray-800 p-0 text-white'>
        <span className='text-body-2'>Device</span>
        <div className='ml-2.5 box-content rounded border border-gray-700'>
          <button
            className={clsx(
              'h-7 w-7 border-none text-lg text-white transition-colors duration-200',
              device === 'desktop' ? 'bg-gray-700' : 'hover:bg-gray-700/50 active:bg-gray-700'
            )}
            onClick={() => setDevice('desktop')}
          >
            <Computer fontSize='inherit' />
          </button>
          <button
            className={clsx(
              'h-7 w-7 border-none text-lg text-white transition-colors duration-200',
              device === 'mobile' ? 'bg-gray-700' : 'hover:bg-gray-700/50 active:bg-gray-700'
            )}
            onClick={() => setDevice('mobile')}
          >
            <PhoneAndroid fontSize='inherit' />
          </button>
        </div>
      </div>
      <div
        className={clsx(
          'flex',
          device === 'mobile' && 'relative flex-1 items-center justify-center overflow-hidden',
          device === 'desktop' && 'flex-1'
        )}
      >
        <div
          data-testid='device-selector-child-container'
          className={clsx(
            device === 'mobile' &&
              'mx-auto h-[calc(90vh-52px)] w-[372px] rounded-xl bg-white shadow-08',
            device === 'desktop' && 'flex-1'
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
